import ClientsAPI from "@/api/clients";
import ContactsAPI from "@/api/contacts";
import { SelectBox } from "@monolith-forensics/monolith-ui";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";

interface OrganizationSelectorProps {
  defaultValue: string;
  queryKey: "contacts" | "clients";
  onChange?: (value: Option) => void;
  error?: string;
}

type Organization = {
  organization: string;
};

type Option = {
  label: string;
  value: string;
};

const apiResolver = {
  contacts: ContactsAPI.getOrganizations,
  clients: ClientsAPI.getOrganizations,
};

const OrganizationSelector: FC<OrganizationSelectorProps> = ({
  defaultValue,
  queryKey,
  onChange,
  error,
}) => {
  const { data: organizations } = useQuery<Organization[]>({
    queryKey: [queryKey, "organizations"],
    queryFn: () => apiResolver[queryKey](),
  });

  const options = organizations?.map(
    (organization): Option => ({
      label: organization?.organization,
      value: organization?.organization,
    })
  );

  return (
    <>
      <SelectBox
        defaultValue={defaultValue}
        onChange={onChange}
        error={error}
        size="sm"
        variant="outlined"
        label="Organization"
        placeholder="Select or enter an organization"
        data={options}
        clearable={true}
        searchable={true}
        allowCustomValue={true}
        openOnFocus={false}
      />
    </>
  );
};

export default OrganizationSelector;
